export default {
  props: {
    isConference: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentBasicRoutes() {
      let currentDomainBasicRoutes = [];

      if (this.isConference || this.inConferenceRoute) {
        currentDomainBasicRoutes = this.conferenceBasicRoutes;
      } else {
        currentDomainBasicRoutes = this.courseBasicRoutes;
      }

      return currentDomainBasicRoutes;
    },
    aboutRoute() {
      return this.currentBasicRoutes[0];
    },
    playerRoute() {
      return this.currentBasicRoutes[1];
    },
    currentRoute() {
      return this.$route.name;
    },
    conferenceBasicRoutes() {
      return ["conference-about", "conference-lesson"];
    },
    courseBasicRoutes() {
      return ["course-about", "lesson"];
    },
    inConferenceRoute() {
      return this.conferenceBasicRoutes.includes(this.$route.name);
    },
  },
};
